<template>
    <basic-container>
        <avue-crud :option="option"
                   :table-loading="loading"
                   :data="data"
                   :page.sync="page"
                   :permission="permissionList"
                   :before-open="beforeOpen"
                   v-model="form"
                   ref="crud"
                   @row-update="rowUpdate"
                   @row-save="rowSave"
                   @row-del="rowDel"
                   @search-change="searchChange"
                   @search-reset="searchReset"
                   @selection-change="selectionChange"
                   @current-change="currentChange"
                   @size-change="sizeChange"
                   @refresh-change="onLoad"
                   @on-load="onLoad">
            <template slot="menuLeft" slot-scope="scope">
                <el-button type="primary"
                           size="small"
                           @click="exportExcel">导出
                </el-button>

                未用物品数量 {{unusedNUm}}
            </template>
            <template slot="menu" slot-scope="scope">
                <el-button type="text"
                           size="small"
                           v-if="permissionList.viewBtn"
                           icon="el-icon-view"
                           @click="openViewDialog(scope.row,permissionList.auditBtn)">查看
                </el-button>
            </template>
            <template slot="projectIdSearch">
                 <el-select v-model="searchForm.projectId" placeholder="请选择">
                    <el-option
                        v-for="item in projectList"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                        </el-option>
                </el-select>
            </template>
            <template slot="deptIdSearch">
                <el-select v-model="searchForm.deptId" placeholder="使用科室" @change="$forceUpdate()">
                    <el-option
                        v-for="item in deptList"
                        :key="item.id"
                        :label="item.fullName"
                        :value="item.id">
                        </el-option>
                </el-select>
            </template>
            <template slot="typeIdSearch">
                <el-select v-model="typeName"  @change="$forceUpdate()" placeholder="物品类型">
                <el-option>
                    <el-tree 
                            :current-node-key="typeName"
                            :data="typeData"
                            :props="defaultProps"
                            @node-click="handleNodeClick">
                    </el-tree>
                </el-option>

                </el-select>
            </template>
            <template slot="consumableName2Search">
                <el-input v-model="searchForm.consumableName2" maxlength="20" showWordLimit placeholder="物品名称" />
                
            </template>
            
          
           
        </avue-crud>
    </basic-container>
</template>

<script>
import {getList,exportE,getSummary} from "@/api/crmedical/warehouse/outbound/unused.js"
    import {mapGetters} from "vuex";
     import {getToken} from '@/util/auth';
    import {
        getProjectList,
        getWarehouseList,
        getDict,
        } from "@/api/crmedical/warehouse/index.js";
import {treeFree} from "@/api/crmedical/warehouse/warehouseconsumabletype";
import {treeDeptsByIds} from "@/api/crmedical/warehouse/outbound/grant.js"
    export default {
  
        data() {
            return {
                unusedNUm:0,
                typeName:'',
                typeData:[],
                defaultProps: {
                    value:'id',
                    children: 'children',
                    label: 'name'
                },
                query: {},
               
                loading: false,
                
                page: {
                    pageSize: 10,
                    currentPage: 1,
                    total: 0
                },
                onloadFlag:false,//为了避免第一次请求必须在projecid赋值后进行
                selectionList: [],
                searchForm:{
                    projectId:'',
                    warehouseId:'',
                    people:''
                },
                projectList:[],//项目名称
                warehouseList:[],//仓库名称
                statusList:[],//状态
                option: {
                    height: 'auto',
                    calcHeight: 30,
                    tip: false,
                    addBtn:false,
                    searchShow: true,
                    searchMenuSpan: 24,
                    menuPosition:'center',
                    border: true,
                    index: true,
                    emptyBtn:true,
                    viewBtn: false,
                    selection: false,
                    dialogClickModal: false,
                    cellBtn:false,
                    menu: false,
                    // menuBtn:false,
                    // menuBtn:false,
                    column: [
                                
                                {
                                    label: "项目名称",
                                    prop: "projectId",
                                    dicUrl: '/api/v4ward/project/getProjectList',
                                    search: true,
                                    hide:true,
                                    type:'select',
                                    searchSpan:6,
                                    searchslot:true,
                                    dataType: 'string',
                                    dicData:[],
                                    props:{
                                        label:'name',
                                        value:'id'
                                    },
                                    value:'',
                                    rules: [{
                                        required: true,
                                        message: "请选择项目",
                                        trigger: "change"
                                    }]
                                },
                                {
                                    label: "物品",
                                    prop: "name",
                                },
                                {
                                    label: "编号",
                                    prop: "code",
                                },
                                {
                                    label: "类型",
                                    prop: "typeName",
                                },
                                {
                                    label: "品牌",
                                    prop: "brand",
                                },

                                {
                                    label: "规格",
                                    prop: "specification",
                                },
                                {
                                    label: "生产商",
                                    prop: "manufacturer",
                                },
                                {
                                    label: "计量单位",
                                    prop: "measuringUnitName",
                                },
                                {
                                    label: "未用数量",
                                    prop: "stockNum",
                                },
                                 
                                
                                {
                                    label: "使用科室",
                                    prop: "deptId",
                                    search: true,
                                    hide:true,
                                    searchSpan:6,
                                    searchslot:true,
                                    type:'select',
                                    rules: [{
                                        required: true,
                                        message: "请选择科室",
                                        trigger: "change"
                                    }]
                                },
                                {
                                    label: "物品类型",
                                    prop: "typeId",
                                    search: true,
                                    searchslot:true,
                                    hide:true,
                                    searchSpan:6,
                                    type:'tree',
                                    dataType:'number',
                                    // dicUrl:'/api/blade-system/dict/dictionary?code=warehouse_requisition_status',
                                    props:{
                                        label:'dictValue',
                                        value:'dictKey'
                                    },
                                    rules: [{
                                        required: true,
                                        message: "请选择状态",
                                        trigger: "change"
                                    }]
                                },
                                {
                                    label: "物品名称",
                                    prop: "consumableName2",
                                    search: true,
                                    searchslot:true,
                                    hide:true,
                                    searchSpan:6,
                                    maxlength: 20,
                                    showWordLimit: true,
                                   
                                },
                                
                             
                          
                              
                             
                                
                                              ]
                },
                data: [],
                userlist: [],
                deptList:[],
        value: [],
        list: [],
        loading: false,
     
      }
            
        },
          mounted() {
            this.list = this.states.map(item => {
                return { value: `value:${item}`, label: `label:${item}` };
            });
        },
        created() {
                this.fetchData();
                setTimeout(()=>{
                    window.onresize = ()=>{
                        this.$refs.crud.$refs.table.doLayout();
                    }
                })
                this.$nextTick(() => {
            setTimeout(()=>{
              this.$refs.crud.$children[1].$children[3].$el.addEventListener("click", ()=>{
                    
                    if(this.option.height == this.bodyHeight - 390){
                      this.option.height = this.bodyHeight - 280
                    }else{
                      this.option.height = this.bodyHeight - 390;
                    }
                    this.$refs.crud.getTableHeight();
                });
              })
        
        });
            this.option.height = this.bodyHeight - 390;
         
        },
        computed: {
            ...mapGetters(["permission",'userInfo']),
            
            ids() {
                let ids = [];
                this.selectionList.forEach(ele => {
                    ids.push(ele.id);
                });
                return ids.join(",");
            }
        },
        watch:{
            'searchForm.projectId'(){
                // this.getWarehouseList();
                this.getTypeList()
            }
        },

        methods: {
            // 获取科室列表
            treeDeptsByIds(){ 
                        treeDeptsByIds().then(res=>{
                                this.deptList = res.data;
                                this.searchForm.deptId = this.deptList[0].id;
                                this.onloadFlag = true;
                                this.onLoad();
                        })
                },
            getTypeList(){
                 treeFree({projectId:this.searchForm.projectId}).then((res) => {
                    this.typeData = res.data;
                });
            },
           
            handleNodeClick(node){
                this.typeName = node.name;
                this.searchForm.typeId = node.id;
                this.$forceUpdate()
                // console.log(this.searchForm)
            },
            // 导出
            exportExcel(){
                this.$message({
                    message: '该功能正在建设中.....',
                    type: 'warning'
                });
                return;
                this.$confirm("是否导出?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                }).then(() => {
                    //导出数据
                    let projectId = '';
                    if (this.query.projectId) {
                        projectId = this.query.projectId;
                    }
                    let warehouseId = '';
                    if (this.query.warehouseId) {
                        warehouseId = this.query.warehouseId;
                    }
                    let typeId = '';
                    if (this.query.typeId) {
                        typeId = this.query.typeId;
                    }

                    let consumableName = '';
                    console.log(this.query.consumableName)
                    if (this.query.consumableName) {
                        consumableName = this.query.consumableName;

                    }
                    window.open(`/api/v4ward/warehouse/stock/export?${this.website.tokenHeader}=${getToken()}
                        &projectId=${projectId}
                        &warehouseId=${warehouseId}
                        &typeId=${typeId}
                        &consumableName=${consumableName}`
                    );
                });
            },
             // 获取仓库列表
            getWarehouseList(){
                    this.searchForm.warehouseId = '';
                    getWarehouseList({projectId:this.searchForm.projectId}).then(res=>{
                            this.warehouseList = res.data;
                            let warehouseIdColumn  = this.findObject(this.option.column, "warehouseId");
                            warehouseIdColumn.dicData = this.warehouseList
                            this.searchForm.warehouseId=this.warehouseList[0].id?this.warehouseList[0].id:'';
                            this.onloadFlag = true;
                            this.onLoad();
                    })
            },
            async fetchData() {
                this.pageLoading = true;
          

                try {
                    //projectList 
                    const resProjectList = await getProjectList();
                    this.projectList = resProjectList.data;
                    this.searchForm.projectId = this.projectList[0]? this.projectList[0].id:'';
                    await treeDeptsByIds().then(res=>{
                                this.deptList = res.data;
                                this.searchForm.deptId = this.deptList[0].id;
                                console.log(32456132454)
                                // this.onloadFlag = true;
                                // this.onLoad();
                    })
                  
                    this.onloadFlag = true;
                    this.onLoad();
                    
                    
                    
                    
                    
                } catch (err) {
                }
                this.pageLoading = false;
                },
    
     
            // 搜索重置方法
            searchReset() {
                this.searchForm.projectId = this.projectList[0]?this.projectList[0].id:'';
                this.searchForm.deptId = this.deptList[0]?this.deptList[0].id:'';
                this.typeName = '';
                this.searchForm.typeId=''
                this.searchForm.consumableName2 = '';
                this.query = {};
                this.$refs.crud.toggleSelection();
                this.onLoad();
            },
            searchChange(params, done) {
                this.query = params;
                this.page.currentPage = 1;
                this.onLoad();
                done();
            },
            selectionChange(list) {
                this.selectionList = list;
            },
            selectionClear() {
                this.selectionList = [];
                this.$refs.crud.toggleSelection();
            },
            currentChange(currentPage) {
                this.page.currentPage = currentPage;
            },
            sizeChange(pageSize) {
                this.page.pageSize = pageSize;
            },
            onLoad(page) {
                if(!this.onloadFlag){
                    return;
                }
                // return
                page = page || this.page;
                this.query.projectId = this.searchForm.projectId || '';//项目
                this.query.deptId =  this.searchForm.deptId || '';//仓库
                this.query.typeId = this.searchForm.typeId || ''//物品类型
                this.query.name = this.searchForm.consumableName2 || '';//物品名称
                this.loading = true;
                console.log(this.query)
                getList(
                    Object.assign({current: page.currentPage, size: page.pageSize}, this.query)
                ).then(({data}) => {
                    this.page.total = data.total;
                    this.data = data.records;
                    this.loading = false;
                    // this.selectionClear();
                });
                getSummary(Object.assign({current: page.currentPage, size: page.pageSize}, this.query))
                .then(({data}) => {
                    this.unusedNUm = data
                });
                
            }
        }
    };
</script>

<style  scoped>


::v-deep .avue-form__menu--center{
    text-align: right;
  }
::v-deep   .avue-crud__search .el-form-item--small.el-form-item{
    width: 100%;
  }
</style>